(function () {
  function updateFilterCount() {
    const urlParams = new URLSearchParams(window.location.search);
    let filterCount = 0;
    for (const [key, value] of urlParams.entries()) {
      if (key !== 'sort_by' && key !== 'page' && key !== 'view' && key !== 'filter.v.availability') {
        filterCount++;
      }
    }

    const filtersToggle = document.querySelector('[data-toggle-filters]');

    if (filtersToggle) {
      let buttonText = filtersToggle.innerHTML;

      if (filterCount === 0) {
        buttonText = buttonText.replace(/\s*$$\d+$$/, '');
      } else {
        if (buttonText.includes('(')) {
          buttonText = buttonText.replace(/$$\d+$$/, `(${filterCount})`);
        } else {
          buttonText = buttonText.replace(/<span>(.+?)<\/span>/, `<span>$1</span> (${filterCount})`);
        }
      }

      filtersToggle.innerHTML = buttonText;
    }

    return filterCount;
  }

  window.updateFilterCount = updateFilterCount;

  document.addEventListener('DOMContentLoaded', updateFilterCount);

  document.addEventListener('ajaxComplete', updateFilterCount);

  let lastUrl = window.location.href;
  setInterval(function () {
    if (lastUrl !== window.location.href) {
      lastUrl = window.location.href;
      updateFilterCount();
    }
  }, 100);
  updateFilterCount();
})();
